export default __webpack_public_path__ + "static/media/gallery_07.3eb8cd60.jpg";